// extracted by mini-css-extract-plugin
export default {"delete-button":"knowledge-base-attachment_delete-button__KQeMD"};